import * as yup from "yup";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import {
  PatientSearchResource,
  patientSearchResourceSchema,
} from "@client/resources/PatientSearchResource";

export const fetchClients = async (
  params?: URLSearchParams,
): Promise<ApiResponse<PatientSearchResource[]>> => {
  const response = await fetchData(
    "/dietitian/clinic/patients/search",
    APIMethods.GET,
    undefined,
    params,
  );
  const responseSchema = yup.object().shape({
    data: yup.array().of(patientSearchResourceSchema).required(),
  });
  return await responseSchema.validate(response);
};

export type ClientDto = PatientSearchResource;
